import { render, staticRenderFns } from "./BusinessnewsUpdate.vue?vue&type=template&id=7f074f98"
import script from "./BusinessnewsUpdate.vue?vue&type=script&lang=js"
export * from "./BusinessnewsUpdate.vue?vue&type=script&lang=js"
import style0 from "./BusinessnewsUpdate.vue?vue&type=style&index=0&id=7f074f98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports